import './App.css';

import { Layout, Menu } from 'antd';

import HomePage from './Pages/Home/index.js';

const { Header, Content, Footer } = Layout;



const items = [
  {key: 0, label: "首页"},
  {key: 1, label: "关于我们"},
  {key: 2, label: "产品展示"},
  {key: 3, label: "解决方案"},
  {key: 4, label: "典型用户"},
  {key: 5, label: "联系我们"}
];

const App = () => {
  return (
    <Layout>
      <Header>
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={['0']}
          items={items}
        />
      </Header>
      <Content>
        <div className='content-div'>
          <HomePage />
        </div>
      </Content>
      <Footer>
        <div>
          北京博昊宇机电设备有限公司
        </div>
        <div>
          北京博昊宇机电设备有限公司 版权所有 京ICP备16026926号
        </div>
      </Footer>
    </Layout>
  );
};
export default App;